import { Sampler } from "tone";
import { observable } from 'mobx';
import { format } from "d3-format";
import { observableStore } from "./game-store";
export default class Stage {

  @observable deTunedSamplers = [];
  @observable fixedSamplers = [];
  label = "";
  @observable items = [-1.0, -0.5, 0, 0.5, 1.0];
  // used for setting scale, which should probably be owned here
  @observable range = 1;
  @observable selectedIndex = 0;
  individualPlay = false;

  checkAnswer() {
    const formatter = format(".2f");
    // a useful data struct of error per sampler at index
    let errors = [];
    this.deTunedSamplers.forEach(function (wrappedSampler) {
      const absoluteError = wrappedSampler.pitchSetOffset +
        wrappedSampler.currentUIOffset;
      const roundedError = parseFloat(formatter(absoluteError));
      errors.push(roundedError);
    });
    const errSum = errors.reduce((accum, item) => {
      return accum+item;
    },0);
    if (errSum === 0.0) {
      if (this.correct === null) {
        this.correct = true;
      }
    }
    else {
      if (this.correct === null) {
        this.correct = false;
      }
    }
    return errSum === 0.0;
  }
  constructor(files, offsets, label) {
    let fixedSamplers = [];
    let deTunedSamplers = [];
    offsets.forEach( (offset, index) => {
      const file = files[index];
      let fixedSamplerObject = {
        isPlaying: false,
        pitchSetOffset: 0,
        currentUIOffset: 0 };

      fixedSamplerObject.sampler = new Sampler(file, function() {
        fixedSamplerObject.samplerReady = true;
      }).toMaster();
      fixedSamplerObject.wrappedTrigger = function(semi) {
        this.isPlaying = true;
        this.sampler.triggerAttack(semi);
        if (this.stopTimer) {
          clearTimeout(this.stopTimer);
        }
        fixedSamplerObject.stopTimer = setTimeout(() => {
          this.isPlaying = false;
        }, 500);
      };

      let deTunedSamplerObject = {
        isPlaying: false,
        pitchSetOffset: offset,
        currentUIOffset: 0 };

      deTunedSamplerObject.sampler = new Sampler(file, function() {
        deTunedSamplerObject.samplerReady = true;
      }).toMaster();
      deTunedSamplerObject.wrappedTrigger = function(semi) {
        this.isPlaying = true;
        this.sampler.triggerAttack(semi);
        if (this.stopTimer) {
          clearTimeout(this.stopTimer);
        }
        this.stopTimer = setTimeout(() => {
          this.isPlaying = false;
        }, 500);
      };

      fixedSamplers.push(fixedSamplerObject);
      deTunedSamplers.push(deTunedSamplerObject);
    });
    this.fixedSamplers = fixedSamplers;
    this.deTunedSamplers = deTunedSamplers;
    this.label = label;
    this.correct = null;
  }
  playFixedAtIndex(index) {
    if (this.individualPlay) {
      this.fixedSamplers[index].wrappedTrigger(0);
    }
    else {
      this.playAllFixed();
    }
  }
  setSemitonesAtIndex(index, semitones) {
    this.deTunedSamplers[index].currentUIOffset = semitones;
  }
  playDetunedAtIndex(index, noPenalty) {
    //should probably use d3 format to round to nearest cent
    const playSum = this.deTunedSamplers[index].pitchSetOffset +
      this.deTunedSamplers[index].currentUIOffset;
    this.deTunedSamplers[index].wrappedTrigger(playSum);
    if (this.deTunedSamplers[index].pitchSetOffset === 0) {
      observableStore.wrongPitchPlayed(noPenalty);
    }
  }
  playAllTuned() {
    this.deTunedSamplers.forEach( (tuner) => {
      const playSum = tuner.pitchSetOffset +
        tuner.currentUIOffset;
      tuner.wrappedTrigger(playSum);
    });
  }
  playAllFixed() {
    this.fixedSamplers.forEach((wrapped) => {
      wrapped.wrappedTrigger(0);
    });
  }
}



// WEBPACK FOOTER //
// ./src/stores/stage-store.js